import {forwardRef, InputHTMLAttributes} from 'react';

import s from './index.module.scss';

interface IDefaultInputProps extends InputHTMLAttributes<HTMLInputElement> {
    name?: string;
    label?: string;
    valid?: boolean;
    error?: boolean;
    errorMessage?: string;
    required?: boolean;
}

export const Input = forwardRef<HTMLInputElement, IDefaultInputProps>(
    ({label, valid, error, errorMessage, required, ...rest}, ref) => {
        const containerAltStyles = () =>
            `${rest.disabled && s.disabled} ${valid && s.valid} ${error && s.error}`;

        return (
            <div className={s.wrapper}>
                <div className={s.feedbackArea}>
                    {label && (
                        <label className={`${containerAltStyles()} ${required && s.required}`}>
                            {label}
                        </label>
                    )}
                    {error && errorMessage && <div className={s.message}>{errorMessage}</div>}
                </div>
                <div className={`${s.container} ${containerAltStyles()}`}>
                    <input ref={ref} {...rest} />
                </div>
            </div>
        );
    }
);
